import React from 'react';
import {Link} from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { APP_NAME } from '../constants/const';
import { FaFacebook, FaTwitter } from "react-icons/fa"; 

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100  border-t border-b py-30">

                    {/* Top area: Blocks */}
                    {/* <div className="grid sm:grid-cols-12 gap-2 py-2 md:py-12 border-t border-gray-200 lg:ml-11"> */}

                    {/* 1st block */}
                    {/* <div className="col-span-12 lg:col-span-4">
                        <div className="box-border border-b-4 border-blue-900 p-8 bg-gray-200 text-gray-600 text-center rounded-lg xl:w-80 mx-auto">
                            <h3 className="font-bold text-3xl mb-4">{APP_NAME}</h3>
                            <div className='text-md font-medium text-gray-600'>
                                <h5>UAE</h5>
                    
                                <p>adress.</p>
                            </div>
                        </div>
                    </div> */}

                    {/* 2nd block */}
                    {/* <div className="col-span-6 md:col-span-6 lg:col-span-1 ml-7 mx-auto">
                        <h6 className="text-[#013289] text-xl font-bold mb-4 text-secondary">LINKS</h6>
                        <ul className="text-md">
                        <li className="mb-2">
                            <HashLink to="#" className=" hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">About</HashLink>
                        </li>
                        <li className="mb-2">
                            <HashLink to="#" className=" hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Services</HashLink>
                        </li>
                        <li className="mb-2">
                            <HashLink to="#" className=" hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Contact</HashLink>
                        </li>                            
                        </ul>
                    </div> */}

                    {/* 3rd block */}
                    {/* <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
                        <h6 className="text-secondary text-xl font-bold mb-4 ">OUR SERVICES</h6>
                        <ul className="text-md">
                        <li className="mb-2">
                            <Link to="#" className=" hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Web Development</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="#" className=" hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Mobile App Development</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="#" className="hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Domain and Hosting</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="#" className=" hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">General IT Consultations</Link>
                        </li>
                        </ul>
                    </div> */}

                    {/* 4th block */}
                    {/* <div className="col-span-12 text-center mx-auto lg:col-span-3 font-bold uppercase mb-4 text-blue-900 mt-10">
                        <div className="text-xl mb-6 text-white">
                        Contact Us.
                        </div>

                                <div className="text-md font-medium mb-6">
                                Office Location.
                                </div>
                        <div className="mx-auto text-center mt-2">
                                <ul className="flex justify-center mb-4 md:mb-0">
                                    <li>
                                    Phone:
                                        <Link to="#" className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="Twitter">
                                       <FaTwitter className="w-8 h-8 py-2" /> 
                                        </Link>
                                    </li>
                                    <li className="ml-4">
                                    Email:
                                        <Link to="#" className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="Facebook">
                                        <FaFacebook className="w-8 h-8 py-2" /> 
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                    </div>           */}

                    </div>

                    <div className="flex flex-wrap items-center md:justify-between justify-center mx-auto px-4">
                <div className="w-full md:w-4/12 px-4 mx-auto text-center py-2">
                    <div className="text-sm text-gray-200 font-semibold py-1">
                    Copyright &copy; {new Date().getFullYear()}{"  "}
                    <HashLink
                        to="#"
                        className=" hover:text-gray-900"
                    >
                        {APP_NAME}
                    </HashLink>. All rights reserved.
                    </div>
                </div>
                {/* </div> */}

                </div>
                
            </footer>
        </>
    )
}
export default Footer;
